<template>
    <div class="panel-content">
                <h3>Informações</h3>
                <form>
                    <div class="row">
                        <div class="col-6">
                            
                            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                                <input class="form__input" id="name" v-model.trim="$v.name.$model"/>
                                <label class="form__label" for="name" :class="{'up': $v.name.$model }">Nome</label>
                                <div class="error" v-if="!$v.name.required">Nome é obrigatório</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                                <input class="form__input" id="email" v-model.trim="$v.email.$model"/>
                                <label class="form__label" for="email" :class="{'up': $v.email.$model }">E-mail</label>
                                <div class="error" v-if="!$v.email.required">E-mail é obrigatório</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group" :class="{ 'form-group--error': $v.company.$error }">
                                <input class="form__input" id="company" v-model.trim="$v.company.$model"/>
                                <label class="form__label" for="company" :class="{'up': $v.company.$model }">Empresa</label>
                                <div class="error" v-if="!$v.company.required">Empresa é obrigatório</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group" :class="{ 'form-group--error': $v.document.$error }">
                                <input class="form__input" id="document" v-model.trim="$v.document.$model"/>
                                <label class="form__label" for="document" :class="{'up': $v.document.$model }">CNPJ</label>
                                <div class="error" v-if="!$v.document.required">CNPJ é obrigatório</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group" :class="{ 'form-group--error': $v.phone.$error }">
                                <input class="form__input" id="phone" v-model.trim="$v.phone.$model"/>
                                <label class="form__label" for="phone" :class="{'up': $v.phone.$model }">Telefone</label>
                                <div class="error" v-if="!$v.phone.required">Telefone é obrigatório</div>
                            </div>
                        </div>
                    </div>
                    <div class="buttons">
                        <button>Salvar alterações</button>
                        <button class="white">Cancelar alterações</button>
                    </div>
                </form>
            </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: "Info",
    data(){
        return{
            name: "",
            email: "",
            company: "",
            document: "",
            phone: ""
        }
    },
    validations: {
        name: {
            required
        },
        email: {
            required
        },
        company: {
            required
        },
        document: {
            required
        },
        phone: {
            required
        }
        
    },
    methods: {
        save(){

        }
    },
}
</script>